// source: pbtypes/vehicle/skills/actions/take_panorama/take_panorama.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_skills_mission_camera_settings_pb = require('../../../../../pbtypes/vehicle/skills/mission_camera_settings_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_mission_camera_settings_pb);
goog.exportSymbol('proto.skills.PanoramaMode', null, global);
goog.exportSymbol('proto.skills.PanoramaMode.Enum', null, global);
goog.exportSymbol('proto.skills.TakePanoramaActionArgs', null, global);
goog.exportSymbol('proto.skills.TakePanoramaActionStateData', null, global);
goog.exportSymbol('proto.skills.TakePanoramaResultData', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TakePanoramaActionArgs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TakePanoramaActionArgs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TakePanoramaActionArgs.displayName = 'proto.skills.TakePanoramaActionArgs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.PanoramaMode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.PanoramaMode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.PanoramaMode.displayName = 'proto.skills.PanoramaMode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TakePanoramaResultData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TakePanoramaResultData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TakePanoramaResultData.displayName = 'proto.skills.TakePanoramaResultData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.TakePanoramaActionStateData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.TakePanoramaActionStateData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.TakePanoramaActionStateData.displayName = 'proto.skills.TakePanoramaActionStateData';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TakePanoramaActionArgs.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TakePanoramaActionArgs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TakePanoramaActionArgs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TakePanoramaActionArgs.toObject = function(includeInstance, msg) {
  var f, obj = {
panoramaMode: jspb.Message.getFieldWithDefault(msg, 4, 0),
cameraSettings: (f = msg.getCameraSettings()) && pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings.toObject(includeInstance, f),
photoSettings: (f = msg.getPhotoSettings()) && pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TakePanoramaActionArgs}
 */
proto.skills.TakePanoramaActionArgs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TakePanoramaActionArgs;
  return proto.skills.TakePanoramaActionArgs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TakePanoramaActionArgs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TakePanoramaActionArgs}
 */
proto.skills.TakePanoramaActionArgs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 4:
      var value = /** @type {!proto.skills.PanoramaMode.Enum} */ (reader.readEnum());
      msg.setPanoramaMode(value);
      break;
    case 5:
      var value = new pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings;
      reader.readMessage(value,pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings.deserializeBinaryFromReader);
      msg.setCameraSettings(value);
      break;
    case 6:
      var value = new pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings;
      reader.readMessage(value,pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings.deserializeBinaryFromReader);
      msg.setPhotoSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TakePanoramaActionArgs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TakePanoramaActionArgs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TakePanoramaActionArgs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TakePanoramaActionArgs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPanoramaMode();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getCameraSettings();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings.serializeBinaryToWriter
    );
  }
  f = message.getPhotoSettings();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional PanoramaMode.Enum panorama_mode = 4;
 * @return {!proto.skills.PanoramaMode.Enum}
 */
proto.skills.TakePanoramaActionArgs.prototype.getPanoramaMode = function() {
  return /** @type {!proto.skills.PanoramaMode.Enum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.skills.PanoramaMode.Enum} value
 * @return {!proto.skills.TakePanoramaActionArgs} returns this
 */
proto.skills.TakePanoramaActionArgs.prototype.setPanoramaMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional CameraSettings camera_settings = 5;
 * @return {?proto.skills.CameraSettings}
 */
proto.skills.TakePanoramaActionArgs.prototype.getCameraSettings = function() {
  return /** @type{?proto.skills.CameraSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_mission_camera_settings_pb.CameraSettings, 5));
};


/**
 * @param {?proto.skills.CameraSettings|undefined} value
 * @return {!proto.skills.TakePanoramaActionArgs} returns this
*/
proto.skills.TakePanoramaActionArgs.prototype.setCameraSettings = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.TakePanoramaActionArgs} returns this
 */
proto.skills.TakePanoramaActionArgs.prototype.clearCameraSettings = function() {
  return this.setCameraSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.TakePanoramaActionArgs.prototype.hasCameraSettings = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional PhotoSettings photo_settings = 6;
 * @return {?proto.skills.PhotoSettings}
 */
proto.skills.TakePanoramaActionArgs.prototype.getPhotoSettings = function() {
  return /** @type{?proto.skills.PhotoSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_skills_mission_camera_settings_pb.PhotoSettings, 6));
};


/**
 * @param {?proto.skills.PhotoSettings|undefined} value
 * @return {!proto.skills.TakePanoramaActionArgs} returns this
*/
proto.skills.TakePanoramaActionArgs.prototype.setPhotoSettings = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.skills.TakePanoramaActionArgs} returns this
 */
proto.skills.TakePanoramaActionArgs.prototype.clearPhotoSettings = function() {
  return this.setPhotoSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.skills.TakePanoramaActionArgs.prototype.hasPhotoSettings = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.PanoramaMode.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.PanoramaMode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.PanoramaMode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.PanoramaMode.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.PanoramaMode}
 */
proto.skills.PanoramaMode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.PanoramaMode;
  return proto.skills.PanoramaMode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.PanoramaMode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.PanoramaMode}
 */
proto.skills.PanoramaMode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.PanoramaMode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.PanoramaMode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.PanoramaMode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.PanoramaMode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.skills.PanoramaMode.Enum = {
  UNSPECIFIED: 0,
  HORIZONTAL: 1,
  VERTICAL: 2,
  SPHERE: 3
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TakePanoramaResultData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TakePanoramaResultData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TakePanoramaResultData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TakePanoramaResultData.toObject = function(includeInstance, msg) {
  var f, obj = {
numPhotosTaken: jspb.Message.getFieldWithDefault(msg, 1, 0),
numFailedPhotos: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TakePanoramaResultData}
 */
proto.skills.TakePanoramaResultData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TakePanoramaResultData;
  return proto.skills.TakePanoramaResultData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TakePanoramaResultData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TakePanoramaResultData}
 */
proto.skills.TakePanoramaResultData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumPhotosTaken(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setNumFailedPhotos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TakePanoramaResultData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TakePanoramaResultData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TakePanoramaResultData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TakePanoramaResultData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNumPhotosTaken();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getNumFailedPhotos();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 num_photos_taken = 1;
 * @return {number}
 */
proto.skills.TakePanoramaResultData.prototype.getNumPhotosTaken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TakePanoramaResultData} returns this
 */
proto.skills.TakePanoramaResultData.prototype.setNumPhotosTaken = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 num_failed_photos = 2;
 * @return {number}
 */
proto.skills.TakePanoramaResultData.prototype.getNumFailedPhotos = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.skills.TakePanoramaResultData} returns this
 */
proto.skills.TakePanoramaResultData.prototype.setNumFailedPhotos = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.TakePanoramaActionStateData.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.TakePanoramaActionStateData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.TakePanoramaActionStateData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TakePanoramaActionStateData.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.TakePanoramaActionStateData}
 */
proto.skills.TakePanoramaActionStateData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.TakePanoramaActionStateData;
  return proto.skills.TakePanoramaActionStateData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.TakePanoramaActionStateData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.TakePanoramaActionStateData}
 */
proto.skills.TakePanoramaActionStateData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.TakePanoramaActionStateData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.TakePanoramaActionStateData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.TakePanoramaActionStateData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.TakePanoramaActionStateData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


goog.object.extend(exports, proto.skills);
